import { useMemo, useCallback } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { TableCell } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import { sortDirLabel } from "helpers/sorts"
import SortIcon from "components/sort-icon"
import OPTooltip from "components/material/tooltip"
import { TOOLTIP_ENTER_DELAY_MS } from "helpers/constants"

export default function ContributorsDetailsSorting({ id, label, align, sort, order, infoText }) {
  const activeSortingClassNames = useMemo(() => order.by === id && ({
    sorting: true,
    [order.dir]: true,
    absolute: order.abs,
  }), [id, order])

  const { sorting } = activeSortingClassNames

  const sortBy = useCallback(() => {
    return sort({ by: id, current: order })
  }, [id, sort, order])

  return (
    <TableCell
      align={align}
      className={classNames(activeSortingClassNames)}
      title={sortDirLabel(order)}
      onClick={sortBy}
    >
      {sorting && <SortIcon direction={order.dir} absolute={order.abs} /> }
      {label}
      {infoText && (
        <OPTooltip
          enterDelay={TOOLTIP_ENTER_DELAY_MS}
          title={infoText}
          placement="bottom-start"
        >
          <InfoOutlined fontSize="small" style={{ marginLeft: "4px" }} />
        </OPTooltip>
      )}
    </TableCell>
  )
}

ContributorsDetailsSorting.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  align: PropTypes.string,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  infoText: PropTypes.string,
}
